var hotspotViewState = Object.freeze({
   hidden: 'hidden',
   firstVisible: 'firstVisible',
   visible: 'visible'
});

export default hotspotViewState;
